var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18.2069,
    height: 22,
    fill: "url(#pattern0_9049_11680)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_9049_11680",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_9049_11680",
    transform: "matrix(0.0113636 0 0 0.00940439 0 -0.00783697)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_9049_11680",
    width: 88,
    height: 108,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABsCAYAAADufnWPAAAAAXNSR0IArs4c6QAAAHhlWElmTU0AKgAAAAgABAEaAAUAAAABAAAAPgEbAAUAAAABAAAARgEoAAMAAAABAAIAAIdpAAQAAAABAAAATgAAAAAAAACQAAAAAQAAAJAAAAABAAOgAQADAAAAAQABAACgAgAEAAAAAQAAAFigAwAEAAAAAQAAAGwAAAAAYazu9wAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAu9JREFUeAHt3UtqAkEUheFqX/hagCOHOnYFrsHtuF8HCuLMgQ6M1dAQMmhOne5LgvkLAgmec6v9LBwodKrXeyVWmMAgbDKDawGAgw8CwAAHCwSP5wQDHCwQPJ4TDHCwQPB4TjDAwQLB4znBAAcLBI/nBAMcLBA8nhMMcLBA8HhOcDDwqOv8//iFSFVVMlsn4Ix7PB7rzT4dOqOOx+P6uR4Oh7Tb7SRk3iIkJj8EsG8nNQGWmPwQwL6d1ARYYvJDAPt2UhNgickPAezbSU2AJSY/BLBvJzUBlpj8EMC+ndQEWGLyQwAX2pV8VJlHd/q4Mm+23+8LL7E9fj6f0+VyqUPX67U93PLocrlMs9ksjUajtN1uW5L6Q8PhsA6vViu51Ak477LZbOTNlOBgMEj3+72OdgGeTqepQe7rGpvTm+eqqzNwPiF9rnxKmifSZW5+oZo5fV1jMy/PVldnnfV6re4l5W63WzqdTlK2LTSZTNJ8Pk+LxSL1fY1t+/58TH8pfjb5WxIAWGLyQwD7dlITYInJDwHs20lNgCUmPwSwbyc1AZaY/BDAvp3UBFhi8kMA+3ZSE2CJyQ8B7NtJTYAlJj8EsG8nNQGWmPwQwL6d1ARYYvJDAPt2UhNgickPAezbSU2AJSY/BLBvJzUBlpj8EMC+ndQEWGLyQwD7dlITYInJDwHs20lNgCUmPwSwbyc1AZaY/BDAvp3UBFhi8kMA+3ZSE2CJyQ8B7NtJTYAlJj8EsG8nNQGWmPwQwL6d1ARYYvJDAPt2UhNgickPAezbSU2AJSY/BLBvJzUBlpj8EMC+ndQEWGLyQwD7dlITYInJDwHs20lNgCUmP/SRwM39zTLL9999Jr9Zvf+Dy8uv9998PB4p/+T1fD7tDfIN7ppbIeZ7p/3W+nPAvwURte9HvkVEYTlzAXbUCjoAF2A5UYAdtYIOwAVYThRgR62gA3ABlhMF2FEr6ABcgOVEAXbUCjoAF2A5UYAdtYIOwAVYTvQLN8Q5uPbwx/oAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTGrey);
export default __webpack_public_path__ + "static/media/T-grey.f0abeae0de8da01df0c0d0d4dd71510e.svg";
export { ForwardRef as ReactComponent };